export default "__VITE_ASSET__KnHhvHCr__"